export class LatestFormSubmissionRow {
  id: string;
  formName: string;
  respondentId: string;
  respondentFullName: string;
  formStatus: string;
  submissionDate: Date;

  constructor(init?: Partial<LatestFormSubmissionRow>) {
    Object.assign(this, init);
  }
}
